import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";

export function SystemStatusSection() {
  const { data: statuses, isLoading } = useQuery({
    queryKey: ["systemStatus"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("system_status")
        .select("*")
        .order("component_name");

      if (error) throw error;
      return data;
    },
  });

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "operational":
        return <Badge variant="success">Operativ</Badge>;
      case "degraded":
        return <Badge variant="warning">Redusert ytelse</Badge>;
      case "outage":
        return <Badge variant="destructive">Utilgjengelig</Badge>;
      default:
        return <Badge>Ukjent</Badge>;
    }
  };

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-[100px] w-full" />
        <Skeleton className="h-[100px] w-full" />
        <Skeleton className="h-[100px] w-full" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {statuses?.map((status) => (
        <Card key={status.id}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">
              {status.component_name}
            </CardTitle>
            {getStatusBadge(status.status)}
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              {status.description}
            </p>
            {status.last_incident_at && (
              <p className="text-xs text-muted-foreground mt-2">
                Siste hendelse: {new Date(status.last_incident_at).toLocaleString()}
              </p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}